<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>動能-Service</h2>
            <h2 style="padding-top: 10px;">{{info}}</h2>
            <h2 style="padding-top: 10px;">{{infoDetail}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area ptb-100">
    <div class="container" style="max-width: 80%;">
        <div class="services-details-overview" style="justify-content: space-evenly;align-items: center; padding-top: 15px;">

            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{firstTitle}}</h3>
                <p [innerHTML]="firstContent"></p>
            </div>
            <img [src]="firstImg" alt="image" class="solution-details-pic">
            <!-- <div class="services-details-image wow fadeInUp">
                <img [src]="firstImg" alt="image">
            </div> -->
        </div>

        <div class="services-details-overview" style="justify-content: space-evenly;align-items: center; padding-top: 15px;">

            <img [src]="secondImg" alt="image" class="solution-details-pic">
            <!-- <div class="services-details-image wow fadeInUp">
                <img [src]="secondImg" alt="image">
            </div> -->
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{secondTitle}}</h3>
                <p [innerHTML]="secondContent"></p>
            </div>
        </div>

        <div class="services-details-overview" style="justify-content: space-evenly;align-items: center; padding-top: 15px;" *ngIf="info === '企業混合雲'">
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{thirdTitle}}</h3>
                <p [innerHTML]="thirdContent"></p>
            </div>
            <img [src]="thirdImg" alt="image" class="solution-details-pic">
        </div>

        <div class="services-details-overview" style="justify-content: space-evenly;align-items: center; padding-top: 15px;" *ngIf="info === '企業混合雲'">
            <img [src]="fourthImg" alt="image" class="solution-details-pic">
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{fourthTitle}}</h3>
                <p [innerHTML]="fourthContent"></p>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->